import Fulllayout from '../layouts/fulllayout.jsx';
import Login from '../views/ui-container/login.jsx';
var indexRoutes = [
    { path: '/login', component: Login },
    { path: '/', name: 'Starter', component: Fulllayout }
];
export default indexRoutes;
